import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onError", "onExpired", "onResolved", "theme", "isEmbedded", "recaptchaPosition"];
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateRecaptchaToken } from '../store/google-recaptcha/action-creators';
import { getTestV2SiteKey, getV2SiteKey } from '../store/google-recaptcha/sitekeys';
import { getQueryParams } from '../routing/getQueryParams';
import { getIsQa } from '../constants/apiEnvironments';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledRecaptchaCheckbox = styled.div.withConfig({
  displayName: "RecaptchaCheckbox__StyledRecaptchaCheckbox",
  componentId: "cxhkpl-0"
})(["display:flex;justify-content:", ";align-items:center;margin-block:", ";"], ({
  $recaptchaPosition
}) => $recaptchaPosition === 'left' ? 'flex-start' : 'center', ({
  theme
}) => theme.space['1000']);
export const RecaptchaCheckbox = _ref => {
  let {
      onError,
      onExpired,
      onResolved,
      theme = 'light',
      isEmbedded,
      recaptchaPosition
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const recaptcha = window.grecaptcha;
  const queryParams = getQueryParams();
  const shouldSimulateRecaptchaFailure = queryParams['simulateRecaptchaFailure'] === 'true' && getIsQa();
  const verifyCallback = useCallback((token, googleRecaptchasitekey) => {
    dispatch(updateRecaptchaToken(token, googleRecaptchasitekey));
    onResolved(token);
  }, [dispatch, onResolved]);
  const expiredCallback = useCallback(() => {
    onExpired();
    recaptcha.enterprise.reset();
  }, [onExpired, recaptcha]);
  const errorCallback = useCallback(error => {
    onError(error);
  }, [onError]);
  const [widgetId, setWidgetId] = useState(null);
  useEffect(() => {
    if (!recaptcha || !recaptcha.enterprise) {
      errorCallback(`The recaptcha is not available or not loaded`);
      return;
    }
    const recaptchaSiteKey = shouldSimulateRecaptchaFailure ? getTestV2SiteKey() : getV2SiteKey();
    recaptcha.enterprise.ready(() => {
      const canRenderRecaptcha = widgetId === null && containerRef.current && recaptcha.enterprise.render;
      if (canRenderRecaptcha) {
        setWidgetId(recaptcha.enterprise.render(containerRef.current, {
          sitekey: recaptchaSiteKey,
          theme,
          size: isEmbedded ? 'compact' : 'normal',
          callback: token => verifyCallback(token, recaptchaSiteKey),
          'expired-callback': expiredCallback,
          'error-callback': errorCallback
        }));
      }
    });
  }, [widgetId, errorCallback, expiredCallback, verifyCallback, theme, recaptcha, isEmbedded, shouldSimulateRecaptchaFailure]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledRecaptchaCheckbox, Object.assign({
      $recaptchaPosition: recaptchaPosition,
      ref: containerRef
    }, props))
  });
};